export function getInitials(fullName: string): string {
  const trimmed = fullName.trim();
  if (!trimmed) {
    return '';
  }

  const parts = trimmed.split(/\s+/).filter(Boolean);
  const firstWord = parts[0];
  if (!firstWord) {
    return '';
  }

  if (parts.length === 1) {
    return firstWord.charAt(0).toUpperCase();
  }

  const lastWord = parts[parts.length - 1] ?? firstWord;
  return `${firstWord.charAt(0)}${lastWord.charAt(0)}`.toUpperCase();
}
